const NODE_CRITERIA_FIELDS = ['accuracy'];
const NODE_TAG_CRITERIA_TYPE = 'tag_name';

export const NODEDEFAULTDATA = {
  is_timed: false,
  attempt_location: 'INCLASS',
  points_available: 50,
  complete_in: 5,
  sheet_time: 2400,
  worksheet_id: '',
  is_optional: false,
  is_live: false,
  node_type: 'GENERAL',
  unlock_interval: 0,
  completionData: [
    [
      {
        attribute: 'accuracy',
        attributeValue: 50,
        operator: '>',
      },
    ],
  ],
  reattemptData: [
    [
      {
        attribute: 'accuracy',
        attributeValue: 90,
        operator: '<',
      },
    ],
  ],
  tags: [],
};

export function deSerializeCriteria(criteria, i) {
  let nodeID = '';
  let criteriaObj = [];
  let criteriaLeft = null;
  let criteriaRight = null;
  if (criteria._type === 'or') {
    criteriaLeft = deSerializeCriteria(criteria['left'], i + 1);
    criteriaRight = deSerializeCriteria(criteria['right'], i + 1);
    if (!Array.isArray(criteriaLeft[0])) {
      criteriaObj.push([criteriaLeft[0]]);
    } else if (!Array.isArray(criteriaLeft[0][0])) {
      criteriaObj.push(criteriaLeft[0]);
    } else {
      criteriaObj.push(...criteriaLeft[0]);
    }
    if (!Array.isArray(criteriaRight[0])) {
      criteriaObj.push([criteriaRight[0]]);
    } else if (!Array.isArray(criteriaRight[0][0])) {
      criteriaObj.push(criteriaRight[0]);
    } else {
      criteriaObj.push(...criteriaRight[0]);
    }
    nodeID = criteriaLeft[1];
  }
  if (criteria._type === 'and') {
    criteriaLeft = deSerializeCriteria(criteria['left'], i + 1);
    criteriaRight = deSerializeCriteria(criteria['right'], i + 1);
    if (!Array.isArray(criteriaLeft[0])) {
      criteriaObj.push(criteriaLeft[0]);
    } else {
      criteriaObj.push(...criteriaLeft[0]);
    }
    if (!Array.isArray(criteriaRight[0])) {
      criteriaObj.push(criteriaRight[0]);
    } else {
      criteriaObj.push(...criteriaRight[0]);
    }
    nodeID = criteriaLeft[1];
  }
  if (criteria._type === 'comparison') {
    if (
      criteria.left._type === 'node' ||
      criteria.left._type === 'tag' ||
      criteria.left._type === NODE_TAG_CRITERIA_TYPE
    ) {
      nodeID = criteria.left.node_id;
      if (criteria.left.attribute === 'completed') {
        let prntCmplt;
        if (criteria.operator === '!=') {
          prntCmplt = !!!+criteria.right.value;
        } else {
          prntCmplt = !!+criteria.right.value;
        }
        criteriaObj = {
          parentCompletion: prntCmplt ? 1 : 0,
          checkUnlock: criteria.left.check_unlock,
        };
      } else if (criteria.left._type === NODE_TAG_CRITERIA_TYPE) {
        criteriaObj = {
          attribute: criteria.left.tag_name,
          operator: criteria.operator,
          attributeValue: criteria.right.value,
          checkUnlock: criteria.left.check_unlock,
        };
      } else {
        criteriaObj = {
          attribute: criteria.left.attribute,
          operator: criteria.operator,
          attributeValue: criteria.right.value,
          checkUnlock: criteria.left.check_unlock,
        };
      }
    } else if (
      criteria.right._type === 'node' ||
      criteria.right._type === 'tag' ||
      criteria.right._type === NODE_TAG_CRITERIA_TYPE
    ) {
      nodeID = criteria.right.node_id;
      if (criteria.right.attribute === 'completed') {
        let prntCmplt;
        if (criteria.operator === '!=') {
          prntCmplt = !!!+criteria.left.value;
        } else {
          prntCmplt = !!+criteria.left.value;
        }
        criteriaObj = {
          parentCompletion: prntCmplt ? 1 : 0,
          checkUnlock: criteria.right.check_unlock,
        };
      } else if (criteria.right._type === NODE_TAG_CRITERIA_TYPE) {
        criteriaObj = {
          attribute: criteria.right.tag_name,
          operator: criteria.operator,
          attributeValue: criteria.left.value,
          checkUnlock: criteria.right.check_unlock,
        };
      } else {
        criteriaObj = {
          attribute: criteria.right.attribute,
          operator: criteria.operator,
          attributeValue: criteria.left.value,
          checkUnlock: criteria.right.check_unlock,
        };
      }
    }
  }
  if (i === 0) {
    if (criteriaObj[0] && !Array.isArray(criteriaObj[0])) {
      criteriaObj = [criteriaObj];
    } else if (!Array.isArray(criteriaObj[0])) {
      criteriaObj = [[criteriaObj]];
    }
  }

  return [criteriaObj, nodeID];
}

export function deSerializeGraphLinks(unlockData, depth) {
  let linkData = [];

  if (unlockData) {
    if (unlockData._type === 'or') {
      let unlockDataLeft = deSerializeGraphLinks(unlockData['left'], depth + 1);
      let unlockDataRight = deSerializeGraphLinks(unlockData['right'], depth + 1);
      if (!Array.isArray(unlockDataLeft) && !Array.isArray(unlockDataRight)) {
        if (Object.keys(unlockDataLeft)[0] !== Object.keys(unlockDataRight)[0]) {
          linkData.push([unlockDataLeft], [unlockDataRight]);
        } else {
          let parsedUnlockDataPack = deSerializeCriteria(unlockData, 0);
          let parsedUnlockData = parsedUnlockDataPack[0];
          let nodeID = parsedUnlockDataPack[1];
          linkData = { [nodeID]: parsedUnlockData };
        }
      } else if (Array.isArray(unlockDataLeft) && !Array.isArray(unlockDataRight)) {
        if (!Array.isArray(unlockDataLeft[0])) {
          linkData.push([...unlockDataLeft], [unlockDataRight]);
        } else {
          linkData.push(...unlockDataLeft, [unlockDataRight]);
        }
      } else if (
        !Array.isArray(unlockDataLeft) &&
        !Array.isArray(unlockDataRight[0]) &&
        Array.isArray(unlockDataRight)
      ) {
        if (!Array.isArray(unlockDataRight[0])) {
          linkData.push([unlockDataLeft], [...unlockDataRight]);
        } else {
          linkData.push([unlockDataLeft], ...unlockDataRight);
        }
      } else {
        if (Array.isArray(unlockDataLeft[0])) {
          linkData.push(...unlockDataLeft);
        } else {
          linkData.push([...unlockDataLeft]);
        }
        if (Array.isArray(unlockDataRight[0])) {
          linkData.push(...unlockDataRight);
        } else {
          linkData.push([...unlockDataRight]);
        }
      }
    }
    if (unlockData._type === 'and') {
      let unlockDataLeft = deSerializeGraphLinks(unlockData['left'], depth + 1);
      let unlockDataRight = deSerializeGraphLinks(unlockData['right'], depth + 1);
      if (!Array.isArray(unlockDataLeft) && !Array.isArray(unlockDataRight)) {
        if (Object.keys(unlockDataLeft)[0] !== Object.keys(unlockDataRight)[0]) {
          linkData.push(unlockDataLeft, unlockDataRight);
        } else {
          let parsedUnlockDataPack = deSerializeCriteria(unlockData, 0);
          let parsedUnlockData = parsedUnlockDataPack[0];
          let nodeID = parsedUnlockDataPack[1];
          linkData = { [nodeID]: parsedUnlockData };
        }
      } else if (Array.isArray(unlockDataLeft) && !Array.isArray(unlockDataRight)) {
        linkData.push(...unlockDataLeft, unlockDataRight);
      } else if (!Array.isArray(unlockDataLeft) && Array.isArray(unlockDataRight)) {
        linkData.push(unlockDataLeft, ...unlockDataRight);
      } else {
        linkData.push(...unlockDataLeft, ...unlockDataRight);
      }
    }
    if (unlockData._type === 'comparison') {
      let parsedUnlockDataPack = deSerializeCriteria(unlockData, 0);
      let parsedUnlockData = parsedUnlockDataPack[0];
      let nodeID = parsedUnlockDataPack[1];
      linkData = { [nodeID]: parsedUnlockData };
    }
    if (depth === 0) {
      if (!Array.isArray(linkData)) {
        linkData = [[linkData]];
      } else if (!Array.isArray(linkData[0])) {
        linkData = [linkData];
      }
    }
  }
  return linkData;
}

export function deSerializeGraphNode(nodeDbData) {
  let reattemptCriteriaPack = deSerializeCriteria(nodeDbData.reattempt_criteria || {}, 0);
  let completionCriteriaPack = deSerializeCriteria(nodeDbData.complete_criteria || {}, 0);
  let reattemptCriteria = reattemptCriteriaPack[0];
  let completionCriteria = completionCriteriaPack[0];
  let linkData = deSerializeGraphLinks(nodeDbData.unlock_criteria || {}, 0);
  let nodeData = Object.assign({}, nodeDbData);
  nodeData['reattemptData'] = reattemptCriteria;
  nodeData['completionData'] = completionCriteria;
  delete nodeData['reattempt_criteria'];
  delete nodeData['complete_criteria'];
  delete nodeData['unlock_criteria'];
  return [nodeData, linkData];
}

export function serializeCriteria(dependencyCriteria, nodeID, tagType) {
  // eslint-disable-next-line
  let parsedCriteriaList = dependencyCriteria.map(orBlock => {
    let orBlockDataList = orBlock.map(andCriteria => {
      if (nodeID) {
        //Serialize Criteria and return when nodeID present
        let andCriteriaData = {};
        if (tagType) {
          andCriteriaData = {
            left: {
              _type: 'tag',
              attribute: andCriteria.attribute,
            },
            operator: andCriteria.operator,
            _type: 'comparison',
            right: {
              value: andCriteria.attributeValue,
              _type: 'num',
            },
          };
        } else if (
          !(andCriteria.parentCompletion === 0 || andCriteria.parentCompletion === 1)
        ) {
          if (!(NODE_CRITERIA_FIELDS.indexOf(andCriteria.attribute) < 0)) {
            andCriteriaData = {
              left: {
                node_id: nodeID,
                _type: 'node',
                attribute: andCriteria.attribute,
                check_unlock: andCriteria.checkUnlock,
              },
              operator: andCriteria.operator,
              _type: 'comparison',
              right: {
                value: andCriteria.attributeValue,
                _type: 'num',
              },
            };
          } else {
            andCriteriaData = {
              left: {
                node_id: nodeID,
                _type: NODE_TAG_CRITERIA_TYPE,
                tag_name: andCriteria.attribute,
                check_unlock: andCriteria.checkUnlock,
              },
              operator: andCriteria.operator,
              _type: 'comparison',
              right: {
                value: andCriteria.attributeValue,
                _type: 'num',
              },
            };
          }
        } else {
          andCriteriaData = {
            left: {
              attribute: 'completed',
              node_id: nodeID,
              _type: 'node',
              check_unlock: andCriteria.checkUnlock,
            },
            operator: '=',
            _type: 'comparison',
            right: {
              value: andCriteria.parentCompletion,
              _type: 'num',
            },
          };
        }
        return andCriteriaData;
      } else {
        //Unlock Status'
        let andCriteriaData;
        Object.entries(andCriteria).forEach(([ndID, criteria]) => {
          let criteriaData = serializeCriteria(criteria, ndID);
          andCriteriaData = criteriaData;
        });
        return andCriteriaData;
      }
    });
    if (orBlockDataList && orBlockDataList.length > 0) {
      let orBlockData = orBlockDataList[0];
      for (var i = 1; i < orBlockDataList.length; i++) {
        let orBlockDataBuilder = {};
        orBlockDataBuilder['left'] = orBlockData;
        orBlockDataBuilder['_type'] = 'and';
        orBlockDataBuilder['right'] = orBlockDataList[i];
        orBlockData = orBlockDataBuilder;
      }
      return orBlockData;
    }
  });
  if (parsedCriteriaList && parsedCriteriaList.length > 0) {
    let parsedData = parsedCriteriaList[0];
    for (var i = 1; i < parsedCriteriaList.length; i++) {
      let parsedCriteriaBuilder = {};
      parsedCriteriaBuilder['left'] = parsedData;
      parsedCriteriaBuilder['_type'] = 'or';
      parsedCriteriaBuilder['right'] = parsedCriteriaList[i];
      parsedData = parsedCriteriaBuilder;
    }
    return parsedData;
  } else {
    return {};
  }
}

export function serializeGraphNode(node, links, lookupTable) {
  // get Node Data from Graph and return DB format
  const nodeID = lookupTable[node.id];
  let dependencyData = [];
  node.ports.forEach(portData => {
    let dependencyCriteriaPerPort = [];
    if (portData.name !== 'bottom') {
      if (portData.links) {
        // eslint-disable-next-line
        portData.links = portData.links.filter(linkID =>
          JSON.stringify(links).includes(linkID),
        );

        dependencyCriteriaPerPort = portData.links.map(linkID => {
          let linkData = links.find(function(obj) {
            return obj.id === linkID;
          });

          let dependencyNodeID;
          if (lookupTable[linkData.source] === nodeID) {
            dependencyNodeID = lookupTable[linkData.target];
          } else if (lookupTable[linkData.target] === nodeID) {
            dependencyNodeID = lookupTable[linkData.source];
          }
          if (dependencyNodeID) {
            return { [dependencyNodeID]: linkData.dependencyData };
          }
        });
        if (dependencyCriteriaPerPort && dependencyCriteriaPerPort !== []) {
          dependencyData.push(dependencyCriteriaPerPort);
        }
      }
    }
  });

  let filteredDependencyData = dependencyData.filter(function(dat) {
    return dat.length !== 0;
  });
  let dependencyCriteria = serializeCriteria(filteredDependencyData);
  let reattemptCriteria = serializeCriteria(node.reattemptData, nodeID);
  let completionCriteria = serializeCriteria(node.completionData, nodeID);
  let nodeData = node.activityNodeData;
  nodeData['id'] = nodeID;
  nodeData['unlock_criteria'] = dependencyCriteria || null;
  nodeData['reattempt_criteria'] = reattemptCriteria;
  nodeData['complete_criteria'] = completionCriteria;
  delete nodeData['dependencyData'];
  delete nodeData['reattemptData'];
  delete nodeData['completionData'];
  delete nodeData['selected'];
  return nodeData;
}
